<td
    class="member-cell d-flex"
    [class.nonreporting]="floaPerson.leftEarly == true"
    [ngClass]="(columns | async)[0].class"
>
    <div class="member-name-icon-container">
        <div
            class="member-name-container row text-left d-flex justify-content-start align-items-center"
            (click)="getFloaPersonDR()"
            [ngClass]="{ indent: floaPerson.isSubordinate == true }"
        >
            <cmps-icon
                class="cmps-cdk-fill-grey-300 cmps-cdk-text-center member-chevron"
                svgIcon="chevron-down"
                *ngIf="
                    floaPerson.bottomRole !== true &&
                    floaPerson.subOrdinates != null
                "
            ></cmps-icon>
            <cmps-icon
                class="cmps-cdk-fill-grey-300 cmps-cdk-text-center member-chevron"
                svgIcon="chevron-right"
                *ngIf="
                    floaPerson.bottomRole !== true &&
                    floaPerson.subOrdinates == null
                "
            ></cmps-icon>
            <div
                class="cmps-cdk-pl-2"
                *ngIf="floaPerson.bottomRole === true"
            ></div>
            <span class="member-name">
                <span class="photo-name-sec">
                    <cmps-icon
                        class="user-icon"
                        svgIcon="account-circle"
                    ></cmps-icon>
                    <span
                        class="user-name-text"
                        [class.underline]="floaPerson.bottomRole == true"
                        [ngbTooltip]="membertooltip"
                        tooltipClass="oa-widget-tooltip"
                        placement="right"
                        container="body"
                    >
                        {{ floaPerson.fullName | titlecase }}
                        <small *ngIf="floaPerson.isTop == false"
                            >({{ floaPerson.role }})</small
                        >
                    </span>
                </span>
            </span>
            <span
                *ngIf="loadingFloaTeam"
                class="expand-icon d-block ml-2"
            >
                <cmps-wait-status></cmps-wait-status>
            </span>
        </div>

        <button
            class="expand-metric-button"
            (click)="getFloaPersonMetrics()"
        >
            <cmps-icon
                svgIcon="chart-box-outline"
                [ngbTooltip]="metricFocusTpl"
                tooltipClass="oa-widget-tooltip"
                container="body"
                *ngIf="!loadingFloaMetrics && !floaPerson.metrics?.length"
            ></cmps-icon>
            <span
                *ngIf="loadingFloaMetrics"
                class="expand-icon"
            >
                <cmps-wait-status></cmps-wait-status>
            </span>
            <cmps-icon
                svgIcon="close-circle-outline"
                [ngbTooltip]="closeMetricFocusTpl"
                tooltipClass="oa-widget-tooltip"
                container="body"
                *ngIf="!loadingFloaMetrics && floaPerson.metrics?.length"
            ></cmps-icon>
        </button>
    </div>
</td>

<td
    [ngClass]="(columns | async)[1].class"
    class="overall-count"
    [style.color]="floaPerson.oaThresholdColour"
>
    <span
        class="floa-score"
        #a="ngbTooltip"
        [ngbTooltip]="floaTooltip"
        tooltipClass="oa-widget-tooltip"
        (mouseover)="getFloaTooltip(a)"
        placement="top"
        container="body"
    >
        {{ floaPerson.oaScore != null ? floaPerson.oaScore : '-' }}
    </span>
    <span
        class="score-percentage"
        *ngIf="floaPerson.oaScore != null"
        >%</span
    >
</td>

<td
    [ngClass]="(columns | async)[2].class"
    class="overall-count"
>
    {{ floaPerson.expectedOpportunities | number: '1.0-0' }}
</td>

<td
    [ngClass]="(columns | async)[3].class"
    class="p-1"
>
    <div class="fraction-table-container funded-batch">
        <fraction-bar
            *ngIf="floaPerson.oaScore != null"
            [numerator]="floaPerson.fundedCoached"
            [denominator]="floaPerson.fundedUncoached"
            [divisor]="
                floaPerson.maxExpectedOpportunities != null
                    ? floaPerson.maxExpectedOpportunities
                    : floaPerson.expectedOpportunities
            "
            [maxNumerator]="floaPerson.maxCoached"
            [maxDenominator]="floaPerson.maxUncoached"
            [numeratorClass]="'green'"
            [denominatorClass]="'red'"
            [numeratorLabel]="floaPerson.fundedCoached"
            [denominatorLabel]="floaPerson.fundedUncoached"
            [showHoverTooltip]="floaPerson.isSubordinate"
            [hoverTemplate]="fractionHoverTpl"
            [hoverData]="{
                uncoached: floaPerson.percentUncoached,
                coached: floaPerson.percentCoached
            }"
        >
        </fraction-bar>
    </div>
</td>

<ng-template
    #floaTooltip
    let-fundedCoached="fundedCoached"
    let-expected="expected"
>
    <div class="custom-tooltip oatooltip">
        <div class="metric-mini-view">
            <table>
                <tr class="metric-view-divider">
                    <th>
                        {{
                            i18n._7481_FUNDED_COACHED_OPPORTUNITIES | translate
                        }}
                    </th>
                    <td>
                        {{
                            fundedCoached != null
                                ? (fundedCoached | number: '1.0-0')
                                : '-'
                        }}
                    </td>
                </tr>
                <tr class="metric-view-divider">
                    <th>{{ i18n._7482_EXPECTED_OPPORTUNITIES | translate }}</th>
                    <td>
                        {{
                            expected != null
                                ? (expected | number: '1.0-0')
                                : '-'
                        }}
                    </td>
                </tr>
            </table>
        </div>
    </div>
</ng-template>

<ng-template
    #fractionHoverTpl
    let-data="data"
>
    <div class="custom-tooltip oatooltip">
        <div class="metric-mini-view">
            <table>
                <tr class="metric-view-divider">
                    <th>
                        {{
                            i18n._7483___OF_MY_MANAGER_S_COACHED_OPPORTUNITIES
                                | translate
                        }}
                    </th>
                    <td>
                        {{
                            data.coached != null && data.coached > -1
                                ? (data.coached | percent: '1.0')
                                : '-'
                        }}
                    </td>
                </tr>
                <tr class="metric-view-divider">
                    <th>
                        {{
                            i18n._7484___OF_MY_MANAGER_S_UNCOACHED_OPPORTUNITIES
                                | translate
                        }}
                    </th>
                    <td>
                        {{
                            data.uncoached != null && data.uncoached > -1
                                ? (data.uncoached | percent: '1.0')
                                : '-'
                        }}
                    </td>
                </tr>
            </table>
        </div>
    </div>
</ng-template>

<ng-template #metricFocusTpl>
    <div class="custom-tooltip no-min-width oatooltip">
        {{ i18n._7485_METRIC_FOCUS | translate }}
    </div>
</ng-template>
<ng-template #closeMetricFocusTpl>
    <div class="custom-tooltip no-min-width oatooltip">
        {{ i18n._7486_CLOSE_METRIC_FOCUS | translate }}
    </div>
</ng-template>

<ng-template #membertooltip>
    <div
        *ngIf="
            floaPerson.isSubordinate &&
            floaPerson.supergroup &&
            floaPerson.managerId
        "
        class="custom-tooltip offset-right memberdata"
    >
        <div class="metric-mini-view">
            <table>
                <tr class="metric-view-divider">
                    <td>{{ i18n._7373_SUPERGROUP_NAME | translate }}</td>
                    <td>{{ floaPerson.supergroup }}</td>
                </tr>
                <tr class="metric-view-divider">
                    <td>{{ i18n._7374_DAYS_IN_SUPERGROUP | translate }}</td>
                    <td>{{ floaPerson.daysInSupergroup | number: '1.0-0' }}</td>
                </tr>
                <tr class="metric-view-divider">
                    <td>{{ i18n._48_MANAGER | translate }}</td>
                    <td>{{ floaPerson.managerFullName }}</td>
                </tr>
                <tr class="metric-view-divider">
                    <td>{{ i18n._59_ROLE | translate }}</td>
                    <td>{{ floaPerson.role }}</td>
                </tr>
            </table>
        </div>
    </div>
</ng-template>
